import { useState } from "react";
import { baseURL } from "../baseURL";
import axios from "axios";
import Button from "../components/button/button";
import PolicyContainer from "../components/policy/policyContainer";

const PopUpFormNotify = ({
  activeForm,
  formActiveState,
  setFormActiveState,
  onClose,
  onSuccess,
  onError,
}) => {
  const [formData, setFormData] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${baseURL}/api/submit-notifyme-form`, formData);
      if (onSuccess) onSuccess("notify");
    } catch (err) {
      console.error(err);
      onError();
    }
  };

  return (
    <>
      <div className="pop-up-form">
        <div className="form-header">
          <h4>Showcase Registration</h4>
          <div className="close-btn-x" onClick={onClose}>
            <i class="fa-solid fa-xmark"></i>
          </div>
        </div>
        <form id="collabForm" onSubmit={handleSubmit}>
          <p>Registration is currently closed. Get notified when it opens!</p>
          <div className="form-group">
            <label for="firstName">*First Name</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              onChange={handleChange}
              value={formData.firstName || ""}
              required
            />
          </div>
          <div className="form-group">
            <label for="lastName">*Last Name</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              onChange={handleChange}
              value={formData.lastName || ""}
              required
            />
          </div>
          <div className="form-group">
            <label for="email">*Email</label>
            <input
              type="email"
              id="email"
              name="email"
              onChange={handleChange}
              value={formData.email || ""}
              required
            />
          </div>

          <div className="form-group">
            <label for="zipCode">*Zip/Postal Code </label>
            <input
              type="text"
              id="zipCode"
              name="zipCode"
              onChange={handleChange}
              value={formData.zipCode || ""}
              required
              minLength={4}
            />
          </div>

          <Button
            text="Notify Me"
            color="var(--orange)"
            className="pop-up-btn"
          ></Button>
        </form>
        <div className="policy">
          <PolicyContainer text="Notify Me" />
        </div>
        <div className="form-footer">
          <div className="form-close-btn" onClick={onClose}>
            Close
          </div>
        </div>
      </div>
    </>
  );
};

export default PopUpFormNotify;
